<template>
  <div class="SubWrap">
    <div class="left">
      <van-checkbox v-model="checked" checked-color="#7761CF" class="checkBox" @click="selAll()">全选</van-checkbox>
      <p  v-if="!delet">合计:￥{{price}}</p>
    </div>
    <div class="right" v-if="!delet">
      <button @click="sub()">去结算</button>
    </div>
    <div class="right" v-if="delet">
      <button @click="dele()">删除</button>
    </div>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from "vant";
import Vue from "vue";
Vue.use(Checkbox).use(CheckboxGroup);
export default {
    props:["price","delet"],
  data() {
    return {
      checked: false
    };
  },
  methods:{
      selAll(){
        this.$emit("selAll",!this.checked);
      },
      sub(){
        this.$emit("sub");
      },
      dele(){
        this.$emit("del");
      }
  }
};
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.SubWrap {
  overflow: hidden;
  position: fixed;
  bottom: 50px;
  width: 100%;
  background: @white;
  height: 50px;
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  .left {
    float: left;
    display: flex;
    .checkBox {
      margin-left: 20px;
      line-height: 48px;
      font-size: 12px;
      height: 48px;
      vertical-align: middle;
    }
    p {
      margin-left: 10px;
      line-height: 48px;
      font-size: 14px;
      height: 48px;
      vertical-align: middle;
      color: @text;
    }
  }
  .right {
    float: right;
    button {
      width: 80px;
      display: block;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
      // background: linear-gradient(to right, #fa1e8c 0, #fc1e56 100%);
      background: @btn;
      color: @white;
      float: right;
      text-align: center;
      border: 0px;
    }
  }
}
</style>